export const COUNTRY_BY_ISO: Record<string, string> = {
  AF: "Afġānistān",
  AX: "Åland",
  AL: "Shqipëria",
  DZ: "Algeria",
  AS: "Samoa Amelika",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Hayastan",
  AW: "Aruba",
  AU: "Australia",
  AT: "Österreich",
  AZ: "Azərbaycan",
  BS: "Bahamas",
  BH: "Al-Baḥrayn",
  BD: "Banglādēś",
  BB: "Barbados",
  BY: "Belarús",
  BE: "Belgique",
  BZ: "Belize",
  BJ: "Bénin",
  BM: "Bermuda",
  BT: "ʼBrug-yul",
  BO: "Bolivia",
  BA: "Bosna i Hercegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brasil",
  VG: "British Virgin Islands",
  IO: "British Indian Ocean Territory",
  BN: "Brunei",
  BG: "Bălgariya",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kâmpŭchéa",
  CM: "Cameroun",
  CA: "Canada",
  CV: "Cabo Verde",
  KY: "Cayman Islands",
  CF: "République centrafricaine",
  TD: "Tchad",
  CL: "Chile",
  CN: "Zhōngguó",
  HK: "Xianggang",
  MO: "Àomén",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comores",
  CG: "Congo",
  CD: "République démocratique du Congo",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Côte d'Ivoire",
  HR: "Hrvatska",
  CU: "Cuba",
  CY: "Kýpros",
  CZ: "Česká republika",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "República Dominicana",
  EC: "Ecuador",
  EG: "Mişr",
  SV: "El Salvador",
  GQ: "Guinea Ecuatorial",
  ER: "Ertra",
  EE: "Eesti",
  ET: "Ityop'iya",
  FK: "Falkland Islands",
  FO: "Føroyar",
  FJ: "Fiji",
  FI: "Suomi",
  FR: "France",
  GF: "Guyane française",
  PF: "Polynésie française",
  TF: "Terres australes et antarctiques françaises",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Sakartvelo",
  DE: "Deutschland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Elláda",
  GL: "Kalaallit Nunaat",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinée",
  GW: "Guiné-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HM: "Heard Island and McDonald Islands",
  VA: "Città del Vaticano",
  HN: "Honduras",
  HU: "Magyarország",
  IS: "Ísland",
  IN: "Bhārat",
  ID: "Indonesia",
  IR: "Irān",
  IQ: "Al-'Irāq",
  IE: "Éire",
  IM: "Isle of Man",
  IL: "Yiśra'el",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Nihon",
  JE: "Jersey",
  JO: "Al-'Urdun",
  KZ: "Qazaqstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Al-Kuwayt",
  KG: "Qırğızstan",
  LA: "Lāo",
  LV: "Latvija",
  LB: "Lubnān",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Lībyā",
  LI: "Liechtenstein",
  LT: "Lietuva",
  LU: "Lëtzebuerg",
  MK: "North Macedonia",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongol",
  ME: "Crna Gora",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Moçambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NC: "Nouvelle-Calédonie",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norge",
  OM: "'Umān",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Filasṭīn",
  PA: "Panamá",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Perú",
  PH: "Pilipinas",
  PN: "Pitcairn Islands",
  PL: "Polska",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qaṭar",
  RE: "Réunion",
  RO: "România",
  RU: "Rossiya",
  RW: "Rwanda",
  BL: "Saint Barthélemy",
  SH: "Saint Helena, Ascension and Tristan da Cunha",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (French part)",
  SX: "Saint Martin (Dutch part)",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé e Príncipe",
  SA: "Al-'Arabīyah as-Su'ūdīyah",
  SN: "Sénégal",
  RS: "Srbija",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovensko",
  SI: "Slovenija",
  SB: "Solomon Islands",
  SO: "Soomaaliya",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "España",
  LK: "Sri Lanka",
  SD: "Sūdān",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Eswatini",
  SE: "Sverige",
  CH: "Schweiz",
  SY: "Sūrīyah",
  TW: "Taiwan",
  TJ: "Tojikiston",
  TZ: "Tanzania",
  TH: "Prathet Thai",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tūnis",
  TR: "Türkiye",
  TM: "Türkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraїna",
  AE: "Al-'Imārāt al-'Arabīyah al-Muttaḥidah",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "O'zbekiston",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Việt Nam",
  VI: "United States Virgin Islands",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Al-Yaman",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};

export const COUNTRY_LIST = Object.entries(COUNTRY_BY_ISO).map(([iso, name]) => ({ iso, name }));
